import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { WorkPermit } from 'src/app/shared/interfaces/interfaces';

@Component({
  standalone: false,
  selector: 'app-list-of-ta-requests',
  templateUrl: './list-of-ta-requests.component.html',
  styleUrls: ['./list-of-ta-requests.component.scss'],
})
export class ListOfTaRequestsComponent implements OnInit {
  workPermits: WorkPermit[] = [];
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  page = 1;
  totalPages = 1;

  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private router: Router
  ) {
    this.workPermits = [
      {
        refNo: 30356894,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Pending',
      },
      {
        refNo: 32545698,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 24589657,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Declined',
      },
      {
        refNo: 84785236,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: '',
      },
      {
        refNo: 30356894,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 32545698,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 24589657,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 84785236,
        tenantName: 'Shankar Mukherjee',
        company: 'string',
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
    ];
  }

  ngOnInit(): void {}

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  goToDetails(id: number) {
    this.router.navigate(['/work-entry-permit-details', id], {
      queryParams: {
        viewOnly: false,
      },
    });
  }
}
